module.exports = "/_next/static/images/eac6fa78806e3f771683f547aaca5ede-ppf.png.webp";